import * as React from "react";
import { cn } from "../_internal/cn";
import type { TypeNarrativeContainerProps } from "./NarrativeContainerTypes";

/**
 * NarrativeContainer — the foundational surface that narrative primitives are
 * composed inside. A padded, rounded, elevated card with a content slot and an
 * optional decorative gradient accent that wraps the top-left corner.
 *
 * Styled via `narrative-container.css` (Seeds CSS custom properties). Consumers
 * import the classes through `@sproutsocial/racine/css/components`. Surface
 * overrides are done with standard `className` / `style`.
 */
const NarrativeContainer = React.forwardRef<
  HTMLDivElement,
  TypeNarrativeContainerProps
>(({ children, accent = true, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "seeds-narrative-container",
        { "seeds-narrative-container-accent": accent },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

NarrativeContainer.displayName = "NarrativeContainer";

export default NarrativeContainer;
